export interface MarketLeaderboard {
  marketName: string;
  marketCode: string;
  marketOverview: string;
  metricGroups: MetricGroup[];
}
export interface MetricGroup {
  chartId: string;
  title: string;
  formatString: string;
  metricCode: string;
  class: string;
  data: MetricData[];
}

interface Star {
  value: number;
  formattedValue: string;
}

interface Gap {
  value: number;
  formattedValue: string;
}

interface MetricData {
  timeSlice: string;
  star_1: Star;
  star_5: Star;
  gap: Gap;
}

export interface MetricDescription {
  chartId: string;
  metricCode: string;
  dimension: string;
  longDescription: string;
  title: string;
  metricgroup: string;
  footNoteIndex: string;
}

export interface MetricDescriptions {
  [metricKey: string]: MetricDescription;
}

export interface MetricChartGroupDescriptions {
  chartGroup: MetricDescriptionsGroups[];
  metricDescriptions: MetricDescriptions;
}

export interface GroupFooter {
  footNodeIndex: number;
  footNodeDescription: string;
}

export interface MetricDescriptionsGroups {
  metricGroup: string;
  groupHeader: string;
  groupFooter: GroupFooter[];
  data: MetricDescription[];
}

export interface MetricDescriptionsGroupsKey {
  metricGroup: string;
  groupHeader: string;
  groupFooter: GroupFooter[];
  data: MetricDescriptions;
}

export interface MetricDescriptionsGroupsJSON {
  data: MetricDescriptionsGroups[];
}

export interface MarketChartData {
  chartId: string;
  title: string;
  xAxis: string[];
  star1: number[];
  star5: number[];
  gap: number[];
  footNoteIndex?: string;
  format: Format;
  class: string;
  description?: string;
  metricgroup?: string;
}

interface MarketChartGroup {
  groupHeader: string;
  groupFooter: GroupFooter[];
  metricGroup: string
}

export interface LeaderboardChartData {
  chartData: MarketChartData[],
  marketName: string;
  marketCode: string;
  marketOverview: string;
  chartGroup?: MarketChartGroup;
}
export interface MarketLeaderboardData {
  chartData: ChartDataKey;
  chartDescription: ChartDescriptionKey;
  marketName: string;
  marketCode: string;
  marketOverview: string;
  chartGroup?: MarketChartGroup;
}

interface ChartDataKey {
  [metricKey: string]: MarketChartData[];
}

interface ChartDescriptionKey {
  [metricKey: string]: MetricDescriptionsGroups;
}

export type FormatType = 'percentage' | 'currency';

export interface Format {
  formatType: FormatType;
  precision: number;
}

// User Story #253741: Fixes the issue of yAxis higher than 100% in a chart
const Y_AXIS_100_LIMIT = {
  max: 100.5,
  endOnTick: false,
};

export const CUSTOM_CHART_OPTIONS: CustomChartOptions = {
  'MPF-OCC': {
    yAxis: [{
      ...Y_AXIS_100_LIMIT
    }]
  }, 
  'RENEW-CONVERSION': {
    yAxis: [{
      ...Y_AXIS_100_LIMIT
    }]
  }
};

interface CustomChartOptions {
  [metricKey: string]: Highcharts.Options;
};



// WEBPACK FOOTER //
// ./src/app/core/model/MarketLeaderboard.ts